import React, { useContext, useEffect, useState } from "react";
import { Container, Row, Col, Alert } from "react-bootstrap";
import { Link } from "react-router-dom";
import TransactionItem from "./Component/TransactionItem";
// import { ArrowRightShort, ExclamationCircle } from "react-bootstrap-icons";
import { isMobile } from "react-device-detect";
import ApiUserTransaction from "./../../../core/api/api.userTransaction";
import SplitNumber from "../../components/SplitNumber";
import ContextApp from "./../../../core/contexts/context.app";
import _ from "lodash";
import { Zoom } from "react-awesome-reveal";
import {
  IconArrowRight,
  IconErrorCircle,
  IconNotFound,
} from "../../../assets/icons";
import DottedLoadingData from "../../components/DottedLoadingData";
// import { RotateCircleLoading } from "react-loadingg";
function TransactionList() {
  const [liveData, setLiveData] = useState([]);

  const [isLoading, setIsLoading] = useState(true);
  const ctx = useContext(ContextApp);

  useEffect(() => {
    if (ctx.isAuth) getData();
    else {
    }
  }, [ctx.isAuth]);

  async function getData() {
    try {
      // گرفتن تراکنش های کیف پول
      const response = await ApiUserTransaction.getAllUserTransaction({
        pageNumber: 1,
        pageSize: 50,
      });

      setIsLoading(false);
      if (!_.isEmpty(response) && !_.isEmpty(response.data)) {
        setLiveData(response.data);
      }
      // else setNoData;
    } catch (error) {}
  }
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Container fluid={true} className={`main-content  px-0  }`}>
      {!isMobile ? (
        <Container fluid className="bg-light-3">
          <Container>
            <Row className="pt-3 pb-2 fs-085">
              <Col xs={12} className="px-0">
                <Link to="/" className="text-muted">
                  {" "}
                  صفحه اصلی{" "}
                </Link>{" "}
                /{" "}
                <Link to="/profile" className="text-muted">
                  {" "}
                  پروفایل{" "}
                </Link>{" "}
                /{" "}
                <Link to="/transaction" className="text-muted font-weight-bold">
                  {" "}
                  تراکنش های کیف پول{" "}
                </Link>
              </Col>
            </Row>
          </Container>
        </Container>
      ) : (
        <Container fluid className="bg-light-1 pt-3 pb-2 fs-07">
          <Col xs={12} className="my-auto text-right ">
            <Link to="/" className="text-secondary d-inline-block">
              صفحه اصلی
            </Link>
            <span className="px-1 d-inline-block text-secondary">/</span>

            <Link to="/wallet" className="text-secondary  d-inline-block">
              کیف پول
            </Link>
            <span className="px-1 d-inline-block text-secondary">/</span>

            <div className="text-secondary d-inline-block">
              تراکنش های کیف پول
            </div>
          </Col>
        </Container>
      )}
      <Container className="min-height-page">
        {isLoading ? (
          <div className="mt-3">
            <DottedLoadingData withText="false" />
          </div>
        ) : liveData.length > 0 ? (
          <Row>
            {liveData?.map((itemData, index) => (
              <TransactionItem
                key={index}
                ItemCharge={itemData.balanceType}
                ItemPrice={itemData.amount}
                Amount={itemData.riallBalance}
                ItemTime={itemData.completionTime}
                ItemDate={itemData.completionDate}
                ItemDescription={itemData.description}
                Title={!_.isEmpty(itemData.trackingCode) ? "کد پیگیری : " : ""}
                ItemCode={
                  !_.isEmpty(itemData.trackingCode) ? itemData.trackingCode : ""
                }
              />
            ))}
          </Row>
        ) : (
          <Row className=" pt-xl-0 pt-md-0 transaction-box xl-svg ">
            <div className="full-width text-center px-3 mt-5">
              <IconNotFound fillColor="#b1b1b1" />
              <div class="pb-5 pt-5 text-center col">
                <div class="fs-103  fw-bold">اطلاعاتی جهت نمایش یافت نشد !</div>
                <div class="mt-3 fs-101 text-black-06">
                  تراکنشی ثبت نشده است.
                </div>
              </div>
            </div>
          </Row>
        )}
      </Container>
    </Container>
  );
}
export default TransactionList;
